var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('v-svg',{attrs:{"h":"50%"}},[_vm._v("noData")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('error_message')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }